import React, { useState, useEffect } from 'react';
import "./ImportTransmission.css";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { uploadProductCategoryFile, getProductCategories, uploadProductFile, getProducts, downloadProductFile, downloadTauxFile, uploadTauxFile, getTaux } from '../../services/http';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import ImportContent from '../../components/ImportContent/ImportContent';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';



const ImportTransmission = () => {

    const navigate = useNavigate()
    const states = useSelector((state) => state, shallowEqual);
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [showError, setShowError] = useState(false)
    const [processOngoing, setProcessOngoing] = useState(false)


    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Transmission", firstLevelLink: "/transmission", secondLevelText: "Import", secondLevelLink: "/import-transmission", thirdLevelText: "", thirdLevelLink: ""
            }
        });

        handleMenuSelection("transmission", dispatch, states);
        // handleSubMenuSelection("products", dispatch)
    }, [])


    const handleFileChoose = (e) => {
        const value = e.currentTarget.files[0]
        console.log(value)
        setSelectedFile(value)
    }

    const handleImportData = async (e) => {
        setProcessOngoing(true)
        if (states.selectedFile != null) { 
        console.log(states.importTransmissionDate)
        const mois = states.importTransmissionDate.month;
        const annee = states.importTransmissionDate.year;
        const data = {
            "mois" : mois < 10 ? "0" + mois : mois,
            annee: annee,
            statut: "transmis",
            file: states.selectedFile

        }
        const req = await uploadTauxFile(data, states.userToken.access_token)
        if (req.response && req.response.status !== 200) {
            setProcessOngoing(false)
            if (req.response && req.response.status == 422) {
                var errorMsg = `Import partiellement effectué. Les lignes ${Object.keys(req.response?.data)} sont incorrectes.`;
                toast.warning(errorMsg, {
                    position: toast.POSITION.TOP_RIGHT
                });
                let response = await getTaux(states.userToken.access_token, states.importTransmissionDate.year, 1, "");

                let response_copy = response.data.data.map(obj => ({ ...obj, showDelete: false }))

                dispatch({
                    type: "SET",
                    key: "transmissionList",
                    payload: response_copy,
                });
            } else if(req.response && req.response.status == 400) {
                setProcessOngoing(false)
                toast.error(req.response?.data, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else if(req.status == 200) {
            setProcessOngoing(false)
            toast.success(req?.data, {
                position: toast.POSITION.TOP_RIGHT
            });
            let response = await getTaux(states.userToken.access_token, states.importTransmissionDate.year, 1, "");

            let response_copy = response.data.data.map(obj => ({ ...obj, showDelete: false }))

            dispatch({
                type: "SET",
                key: "transmissionList",
                payload: response_copy,
            });


        }}  else {
            setProcessOngoing(false)
            toast.warning(`Veuillez sélectionner un fichier.`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }

    }
    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing">

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        <div className="row pl-3 mt-2">
                            <button className="btn btn-rounded mb-2 mr-2" onClick={() => { navigate("/transmission") }}><FaArrowAltCircleLeft className="mr-1" /> Retour</button>
                        </div>
                        <ImportContent processOngoing={processOngoing} downloadRequest={downloadTauxFile} fileName={"taux"} type={" taux "} handleImportData={handleImportData} />
                    </div>

                </div>
            </div>
        </div>

    )
}


export default ImportTransmission